import styled from '@emotion/styled';
import React from 'react';
import {useTranslation} from 'react-i18next';
import {secondsToTimeDurationNumber} from 'webapp-lib/utils';

import {TimeEntriesPerDay} from '@lexian/api/timetracker-api';
import {formattedHoursWithUnit} from '_/utilities/temporal';

export function TimetrackerWarnings({
  timeEntriesPerDay,
}: {
  timeEntriesPerDay: TimeEntriesPerDay | null;
}): React.ReactElement {
  const {t} = useTranslation('timetracker');

  const unassignedHours = secondsToTimeDurationNumber(
    timeEntriesPerDay?.durations?.unassigned ?? 0
  );

  const hasUnassigned = unassignedHours > 0;
  const hasOverlappingHours = timeEntriesPerDay?.hasOverlaps;

  const hasErrors = hasUnassigned || hasOverlappingHours;

  return (
    <>
      {hasErrors && (
        <Warning>
          {hasUnassigned && (
            <div>
              {t('components.warnings.unassignedHours', {
                hours: formattedHoursWithUnit(unassignedHours),
              })}
            </div>
          )}
          {hasOverlappingHours && (
            <div>{t('components.warnings.overlappingEntries')}</div>
          )}
        </Warning>
      )}
    </>
  );
}

const Warning = styled.div`
  // box
  background-color: var(--color-alerts-info);
  border-top: var(--color-core-dark-grey) solid 1px;
  padding: var(--gutter-little);

  align-self: flex-end;
  width: 100%;

  & div {
    text-align: center;
  }
`;
